import { team } from "./data/stringConstants";

export function presentNumsArray(nums: number[]) {
  const sortedNums = nums.sort((a, b) => a - b).join(",");
  return sortedNums.replace(/,/g, ", ");
}

export function numsArrAvgCalc(nums: number[]) {
  const calcResult = (nums.reduce((a, b) => a + b, 0) / nums.length).toFixed(2);
  return parseFloat(calcResult);
}

export function adjustTeamName(team: string, season: string) {
  let teamName: string = "";
  if (
    team === "Phoenix Bastards" ||
    team === "Dom's Hawks" ||
    team === "B-Movie Blazers" ||
    team === "The Crashalot Bobcat" ||
    team === "Carden Vermello" ||
    team === "San Antonio McDyess" ||
    team === "LaLaPoets" ||
    team === "Cuban & The Banshees"
  ) {
    teamName = team;
  } else {
    if (team === "philoozers") {
      if (season <= "2016/17") {
        teamName = team;
      } else teamName = "Trust The Process";
    };

    if (team === "Orlando DunkN GoNutz") {
      if (season >= "2019/20" && season <= "2021/22") {
        teamName = "Kind of MAGIC";
      } else if (season >= "2022/23") {
        teamName = "Go Mags";
      } else teamName = team;
    }

    if (team === "Brooklyn Nets") {
      if (season <= "2015/16") teamName = team;
      if (season === "2016/17") teamName = "Brook-Lin Durniets";
      if (season === "2017/18") teamName = "RH Nets";
      if (season === "2018/19") teamName = "Nets In Transition";
      if (season >= "2019/20" && season <= "2021/22") teamName = "Indy Studs";
      if (season >= "2022/23") teamName = "Indy Halicopters";
    }

    if (team === "Detroit Jews 33") {
      if (season <= "2018/19") teamName = team;
      if (season >= "2019/20" && season <= "2020/21") teamName = "TheBrogdon's";
      if (season === "2021/22") teamName = "The NotBrogdon's";
      if (season >= "2022/23") teamName = "The Motor Cades";
    }

    if (team === "Utah Flames") {
      if (season <= "2013/14") teamName = team;
      if (season === "2014/15") teamName = "Utah's Mormon";
      if (season === "2015/16") teamName = "Utah Jazz";
      if (season >= "2016/17" && season <= "2020/21")
        teamName = "All That Jazz";
      if (season >= "2021/22") teamName = "Bam Bam";
    }

    if (team === "chicago88") {
      if (season <= "2011/12") teamName = team;
      if (season >= "2012/13" && season <= "2015/16")
        teamName = "Chicago Kurves";
      if (season >= "2016/17" && season <= "2017/18")
        teamName = "Chicago Gangstas";
      if (season === "2018/19") teamName = "Chicago Fire";
      if (season >= "2019/20") teamName = "Chicago's on Fire";
    }

    if (team === "GSWrandolph") {
      if (season <= "2011/12") teamName = team;
      if (season >= "2012/13" && season <= "2015/16")
        teamName = "San Francisco";
      if (season >= "2016/17" && season <= "2020/21") teamName = "Golden Boys";
      if (season >= "2021/22") teamName = "Golden state of shock";
    }
  }
  return teamName;
}

export function mapManagerToTeam(manager: string, season: string) {
  let teamName: string = "";
  switch (manager) {
    case "יבגני":
      teamName = "Phoenix Bastards";
      break;
    case "דום":
      teamName = "Dom's Hawks";
      break;
    case "ניסים":
      teamName = "B-Movie Blazers";
      break;
    case "איתי":
      if (season <= "2016/17") {
        teamName = "philoozers";
      } else teamName = "Trust The Process";
      break;
    case "מתי":
      switch (true) {
        case season <= "2015/16":
          teamName = "Brooklyn Nets";
          break;
        case season === "2016/17":
          teamName = "Brook-Lin Durniets";
          break;
        case season === "2017/18":
          teamName = "RH Nets";
          break;
        case season === "2018/19":
          teamName = "Nets In Transition";
          break;
        case season >= "2019/20" && season <= "2021/22":
          teamName = "Indy Studs";
          break;
        case season >= "2022/23":
          teamName = "Indy Halicopters";
          break;
      }
      break;
    case "קובי":
      switch (true) {
        case season <= "2018/19":
          teamName = "Detroit Jews 33";
          break;
        case season === "2019/20" || season === "2020/21":
          teamName = "TheBrogdon's";
          break;
        case season === "2021/22":
          teamName = "The NotBrogdon's";
          break;
        case season >= "2022/23":
          teamName = "The Motor Cades";
          break;
      }
      break;
    case "אריאל":
      teamName = "The Crashalot Bobcat";
      break;
    case "ג'יי-דוג":
      teamName = "Orlando DunkN GoNutz";
      break;
    case "אלון":
      teamName = "Orlando DunkN GoNutz";
      break;
    case "זאב":
      teamName = "Orlando DunkN GoNutz";
      break;
    case "דרור":
      teamName = "Kind of MAGIC";
      break;
    case "יוני":
      teamName = "Go Mags";
      break;
    case "מיכאל":
      teamName = "Utah Flames";
      break;
    case "עידן":
      switch (true) {
        case season === "2014/15":
          teamName = "Utah's Mormon";
          break;
        case season === "2015/16":
          teamName = "Utah Jazz";
          break;
        case season >= "2016/17" && season <= "2020/21":
          teamName = "All That Jazz";
          break;
        case season >= "2021/22":
          teamName = "Bam Bam";
          break;
      }
      break;
    case "רן":
      teamName = "chicago88";
      break;
    case "עודד":
      teamName = "Chicago Kurves";
      break;
    case "שירן":
      teamName = "Chicago Gangstas";
      break;
    case "שגיא":
      if (season === "2009/10") {
        teamName = "GSWrandolph";
      } else teamName = "GSWcurry";
      break;
    case "צ'ונסי":
      teamName = "San Francisco";
      break;
    case "איליה":
      teamName = "Golden Boys";
      break;
    case "רוני":
      teamName = "Golden state of shock";
      break;
    case "אסא":
      teamName = "Carden Vermello";
      break;
  }
  return teamName;
}
